import { merge } from "../ms/merge.js";
/**
 * Append MS spectra to a list of peaks
 * @param chromatogram
 * @param peaks - Array of range {from:, to:}
 * @param options
 * @returns A copy of ranges with ms appended
 */
export function appendMass(chromatogram, peaks, options = {}) {
    const { mergeThreshold = 0.3, seriesName = 'ms' } = options;
    const result = [];
    // integrate MS
    for (const peak of peaks) {
        const massSpectrum = merge(chromatogram, {
            mergeThreshold,
            seriesName,
            range: peak,
        });
        result.push({
            ...peak,
            ms: massSpectrum,
        });
    }
    return result;
}
//# sourceMappingURL=append_mass.js.map